export const REDEEM_COACHMARK_STORAGE_KEY = (firebaseUid: string) => `crown_rips_redeem_coachmark_seen:${firebaseUid}`;

// An empty uid short-circuits both helpers: a `…seen:` key with no suffix would be shared by every
// account on the device, so one player's coach-mark would suppress the next player's.
export function hasSeenRedeemCashCoachMark(firebaseUid: string): boolean {
  if (!firebaseUid) {
    return false;
  }
  try {
    return localStorage.getItem(REDEEM_COACHMARK_STORAGE_KEY(firebaseUid)) === '1';
  } catch {
    // Private-mode Safari and friends. Fail open — worst case the coach-mark shows again on a later
    // exit, which beats it never showing at all.
    return false;
  }
}

export function markRedeemCashCoachMarkSeen(firebaseUid: string): void {
  if (!firebaseUid) {
    return;
  }
  try {
    localStorage.setItem(REDEEM_COACHMARK_STORAGE_KEY(firebaseUid), '1');
  } catch {
    // Unwritable storage must never break the lobby this runs in.
  }
}
